<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconBackgroundBlur_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <g clip-path="url(#IconBackgroundBlur_24__a)">
        <g clip-path="url(#IconBackgroundBlur_24__b)">
            <path
                fill="currentColor"
                d="M12 13.557a4.17 4.17 0 0 0 4.167-4.167A4.17 4.17 0 0 0 12 5.225 4.17 4.17 0 0 0 7.834 9.39a4.17 4.17 0 0 0 4.168 4.167"
            />
        </g>
        <path
            fill="currentColor"
            fill-rule="evenodd"
            d="m16.084-7.204 1.237 1.237-22.855 22.855-1.237-1.237zm-5.54.236 1.238 1.237L-5.45 11.502l-1.237-1.237zm11.372 1.71-1.238-1.237L9.963 4.22a5.5 5.5 0 0 1 2.79-.316zM-6.722 20.907 6.817 7.366a5.5 5.5 0 0 0-.315 2.79L-5.485 22.143zm11.634-6.331 2.342-2.342c.308.502.695.952 1.142 1.332l-.4.4a20.5 20.5 0 0 0-3.084.61m.334 10.272-9.638 9.639 1.237 1.237L7.721 24.847zm5.703 0L-4.392 40.19l1.237 1.237 16.58-16.579zm11.36-8.885a11 11 0 0 0-1.636-.838l8.749-8.749 1.237 1.238zm-4.092-1.611a22 22 0 0 0-2.103-.372L29.422.672l1.237 1.237zm-.746-4.992q0 .229-.019.453L26.875.39 25.637-.847l-8.452 8.452c.185.55.286 1.14.286 1.754m-2.64-4.703c.503.308.953.694 1.332 1.142l7.982-7.981-1.238-1.238z"
            clip-rule="evenodd"
        />
        <path
            fill="currentColor"
            d="M19.526 17.558c-1.198-1.283-3.459-2.235-7.526-2.235-4.102 0-6.366.968-7.557 2.267-.32.349-.868.905-1.093 2.346a1.256 1.256 0 0 0 1.24 1.439h14.82c.762 0 1.357-.685 1.24-1.439-.226-1.444-.777-2.01-1.124-2.378"
        />
    </g>
    <defs>
        <clipPath id="IconBackgroundBlur_24__a">
            <rect
                width="20"
                height="20"
                x="2"
                y="2.625"
                fill="currentColor"
                rx=".833"
            />
        </clipPath>
        <clipPath id="IconBackgroundBlur_24__b">
            <path fill="currentColor" d="M2 2.625h20v20H2z" />
        </clipPath>
    </defs>
</svg>
